<template>
  <div id="Lgx02667670704743478461196">
    <div class="relative flex main-border rounded-lg bg-dark">
      <img
        src="https://connect-cdn.intellectualpoint.com/assets/images/simulations/network-plus/02668043895808966262817/graphic.png"
        alt="Logo"
        draggable="false"
        width="100%"
        height="100%"
      />

      <span class="cable" style="width: 14.4%; height: 1.2%; bottom: 49.4%; left: 20.8%" @click="selectCable(0)" />
      <span class="cable" style="width: 5.9%; height: 1.2%; bottom: 58.25%; left: 37.9%" @click="selectCable(1)" />
      <span class="cable" style="width: 23%; height: 1.2%; bottom: 58.25%; left: 44%" @click="selectCable(2)" />
      <span class="cable" style="width: 14%; height: 1.2%; bottom: 58.25%; left: 69.3%" @click="selectCable(3)" />
      <span class="cable" style="width: 9.2%; height: 1.2%; bottom: 49.4%; left: 52.2%" @click="selectCable(4)" />
      <span class="cable" style="width: 5%; height: 1.2%; bottom: 37.8%; left: 39.15%" @click="selectCable(5)" />
      <span class="cable" style="width: 14.2%; height: 1.2%; bottom: 37.8%; left: 55.6%" @click="selectCable(6)" />
      <span class="cable" style="width: 15%; height: 1.2%; bottom: 37.8%; left: 69.8%" @click="selectCable(7)" />

      <span class="cable" style="width: 12%; height: 12%; bottom: 16.6%; left: 8%" @click="vlanUsagePopupActive = true" />
      <span class="cable" style="width: 20%; height: 17.8%; bottom: 15.6%; left: 73.1%" @click="printerPopupActive = true" />

      <span class="cable" style="width: 9%; height: 17%; bottom: 15.6%; left: 35%" @click="remediationPopupActive = true" />
      <span class="cable" style="width: 9%; height: 17%; bottom: 15.6%; left: 51.2%" @click="remediationPopupActive = true" />
      <span class="cable" style="width: 9%; height: 17%; bottom: 71.4%; left: 34%" @click="remediationPopupActive = true" />
      <span class="cable" style="width: 9%; height: 17%; bottom: 71.4%; left: 62.5%" @click="remediationPopupActive = true" />
      <span class="cable" style="width: 9%; height: 17%; bottom: 71.4%; left: 78.5%" @click="remediationPopupActive = true" />
    </div>

    <movable-popup
      refVal="cableTestResultsPopup"
      title="Cable Test Results"
      :active="activeCable !== -1"
      v-on:close="activeCable = -1"
      style="width: fit-content"
    >
      <template v-slot:content>
        <div class="flex flex-col items-center">
          <div class="grid grid-cols-8 gap-2">
            <vs-button
              v-for="(cable, index) in cables"
              size="small"
              :key="index"
              :class="activeCable !== index && 'text-black'"
              :color="activeCable === index ? 'primary' : 'dark'"
              @click="activeCable = index"
            >
              Cable {{ index + 1 }}
            </vs-button>
          </div>

          <div class="flex items-center gap-24 mt-8">
            <div class="flex flex-col gap-4">
              <span class="flex items-center">
                <p class="w-32">Length:</p>
                <p class="font-bold">{{ cables[activeCable].length }}</p>
              </span>
              <span class="flex items-center">
                <p class="w-32">VLAN:</p>
                <p class="font-bold">{{ cables[activeCable].vlan }}</p>
              </span>
              <span class="flex items-center">
                <p class="w-32">Speed:</p>
                <p class="font-bold">{{ cables[activeCable].speed }}</p>
              </span>
              <span class="flex items-center">
                <p class="w-32">Port:</p>
                <p class="font-bold">{{ cables[activeCable].port }}</p>
              </span>
            </div>

            <img
              :src="
                activeCable === 4
                  ? 'https://connect-cdn.intellectualpoint.com/assets/images/simulations/network-plus/02668043895808966262817/cable-alt.png'
                  : 'https://connect-cdn.intellectualpoint.com/assets/images/simulations/network-plus/02668043895808966262817/cable-main.png'
              "
              alt="Logo"
              draggable="false"
              width="40%"
              height="40%"
            />
          </div>
        </div>
      </template>
    </movable-popup>

    <movable-popup
      refVal="vlanUsagePopup"
      title="VLAN Usage"
      :active="vlanUsagePopupActive == true"
      v-on:close="vlanUsagePopupActive = false"
      style="width: fit-content"
    >
      <template v-slot:content>
        <div class="flex flex-col">
          <div class="flex mt-2">
            <div class="flex flex-col gap-4">
              <span class="flex items-center">
                <p class="w-24">VLAN1:</p>
                <p class="font-bold">Default</p>
              </span>
              <span class="flex items-center">
                <p class="w-24">VLAN2:</p>
                <p class="font-bold w-32">Server/HR</p>
                <p class="font-bold text-grey">10.10.2.0/24</p>
              </span>
              <span class="flex items-center">
                <p class="w-24">VLAN3:</p>
                <p class="font-bold w-32">Marketing</p>
                <p class="font-bold text-grey">10.10.3.0/24</p>
              </span>
              <span class="flex items-center">
                <p class="w-24">VLAN4:</p>
                <p class="font-bold w-32">Admin Staff</p>
                <p class="font-bold text-grey">10.10.4.0/24</p>
              </span>
              <span class="flex items-center">
                <p class="w-24">VLAN10:</p>
                <p class="font-bold w-32">PCs</p>
                <p class="font-bold text-grey">10.10.10.0/24</p>
              </span>
              <span class="flex items-center">
                <p class="w-24">VLAN11:</p>
                <p class="font-bold w-32">Printer</p>
                <p class="font-bold text-grey">10.10.11.0/24</p>
              </span>
            </div>
          </div>
        </div>
      </template>
    </movable-popup>

    <movable-popup
      refVal="printerPopup"
      title="Printer"
      :active="printerPopupActive == true"
      v-on:close="printerPopupActive = false"
      style="width: fit-content"
    >
      <template v-slot:content>
        <div class="flex flex-col">
          <span class="mt-2 mb-6">
            <h5>HP Network Configuration Page</h5>
            <p class="text-grey">Model: HP Officejet Pro 8610</p>
          </span>

          <div class="flex flex-col pt-8 mb-6 main-top-border">
            <h5 class="font-bold mb-4">General Information</h5>
            <div class="flex flex-col gap-2 w-full">
              <span class="flex items-center justify-between">
                <p class="">Network Status</p>
                <p class="font-bold text-grey">Ready</p>
              </span>
              <span class="flex items-center justify-between">
                <p class="">Active Connection Type</p>
                <p class="font-bold text-grey">Wired</p>
              </span>
              <span class="flex items-center justify-between gap-8">
                <p class="">URL(s) for Embedded Web Server</p>
                <p class="font-bold text-grey">http://HP4D30EC, http://192.168.2.9</p>
              </span>
              <span class="flex items-center justify-between">
                <p class="">Firmware Revision</p>
                <p class="font-bold text-grey">FDP1CN1347AR</p>
              </span>
              <span class="flex items-center justify-between">
                <p class="">Hostname</p>
                <p class="font-bold text-grey">HP4D30EC</p>
              </span>
              <span class="flex items-center justify-between">
                <p class="">Serial Number</p>
                <p class="font-bold text-grey">Cn3AO1KG42</p>
              </span>
              <span class="flex items-center justify-between">
                <p class="">Internet</p>
                <p class="font-bold text-grey">Not Connected</p>
              </span>
            </div>
          </div>

          <div class="flex flex-col pt-8 mb-6 main-top-border">
            <h5 class="font-bold mb-4">802.3 Wired</h5>
            <div class="flex flex-col gap-2 w-full">
              <span class="flex items-center justify-between">
                <p class="">Hardware Address (MAC)</p>
                <p class="font-bold text-grey">9c:b6:54:4d:30:ec</p>
              </span>
              <span class="flex items-center justify-between">
                <p class="">Link Configuration</p>
                <p class="font-bold text-grey">None</p>
              </span>
            </div>
          </div>

          <div class="flex flex-col pt-8 main-top-border">
            <h5 class="font-bold mb-4">802.3 Wired</h5>
            <div class="flex flex-col gap-2 w-full">
              <span class="flex items-center justify-between">
                <p class="">Hardware Address (MAC)</p>
                <p class="font-bold text-grey">9c:b6:54:4d:30:ec</p>
              </span>
              <span class="flex items-center justify-between">
                <p class="">Link Configuration</p>
                <p class="font-bold text-grey">None</p>
              </span>
            </div>
          </div>

          <div class="flex flex-col pt-4">
            <h5 class="font-bold mb-4">IPv4</h5>
            <div class="flex flex-col gap-2 w-full">
              <span class="flex items-center justify-between">
                <p class="">IP Address</p>
                <p class="font-bold text-grey">10.10.11.56</p>
              </span>
              <span class="flex items-center justify-between">
                <p class="">Subnet Mask</p>
                <p class="font-bold text-grey">255.255.255.0</p>
              </span>
              <span class="flex items-center justify-between">
                <p class="">Default Gateway</p>
                <p class="font-bold text-grey">10.10.11.1</p>
              </span>
              <span class="flex items-center justify-between">
                <p class="">Configuration Source</p>
                <p class="font-bold text-grey">DHCP</p>
              </span>
              <span class="flex items-center justify-between">
                <p class="">Primary DNS Server</p>
                <p class="font-bold text-grey">8.8.8.8</p>
              </span>
              <span class="flex items-center justify-between">
                <p class="">Secondary DNS Server</p>
                <p class="font-bold text-grey">8.8.4.4</p>
              </span>
              <span class="flex items-center justify-between">
                <p class="">Total Packets Transmitted</p>
                <p class="font-bold text-grey">15655</p>
              </span>
              <span class="flex items-center justify-between">
                <p class="">Total Packets Received</p>
                <p class="font-bold text-grey">394068</p>
              </span>
            </div>
          </div>
        </div>
      </template>
    </movable-popup>

    <movable-popup
      refVal="remediationPopup"
      title="Remediations"
      :active="remediationPopupActive == true"
      v-on:close="remediationPopupActive = false"
      style="width: fit-content"
    >
      <template v-slot:content>
        <div class="flex flex-col">
          <span class="flex items-center justify-between gap-16" :style="`margin-bottom: ${remediations.length > 0 ? '1rem' : ''}`">
            <h5>Remediation List</h5>
            <vs-button size="small" type="gradient" @click="addRemediation()">Add Remediation</vs-button>
          </span>
          <div class="grid grid-cols-1 gap-3">
            <div v-for="(remediation, index) in remediations" :key="index" class="flex flex-col gap-6 bg-dark p-4 main-border rounded-lg">
              <span class="flex items-center justify-between">
                <v-select class="w-1/2" v-model="remediation.device" :options="devices" placeholder="Select Device" />
                <vs-button
                  size="small"
                  color="danger"
                  type="gradient"
                  class="w-fit"
                  icon="icon-x"
                  icon-pack="feather"
                  @click="removeRemediation(index)"
                />
              </span>

              <div class="flex flex-col gap-2 bg-light">
                <span class="flex items-center justify-between w-full">
                  <p class="text-lg">Problem</p>
                  <v-select class="w-3/4" v-model="remediation.problem" :options="problems" />
                </span>

                <span class="flex items-center justify-between w-full">
                  <p class="text-lg">Solution</p>
                  <v-select class="w-3/4" v-model="remediation.solution" :options="solutions" />
                </span>
              </div>
            </div>
          </div>
        </div>
      </template>
    </movable-popup>
  </div>
</template>

<script>
import vSelect from 'vue-select';
import MovablePopup from '../../../../../../../../components/popup/MovablePopup';

export default {
  data() {
    return {
      dataLocal: JSON.parse(JSON.stringify(this.data)),
      activeCable: -1,
      vlanUsagePopupActive: false,
      printerPopupActive: false,
      remediationPopupActive: false,

      cables: [
        {
          length: '22M',
          vlan: 'VLAN 2',
          speed: '1000 FDX',
          port: 'GigabitEthernet0/1',
        },
        {
          length: '103M',
          vlan: 'VLAN 3',
          speed: '1000 FDX',
          port: 'GigabitEthernet0/4',
        },
        {
          length: '18M',
          vlan: 'VLAN 2',
          speed: '1000 FDX',
          port: 'GigabitEthernet0/3',
        },
        {
          length: '20M',
          vlan: 'VLAN 1',
          speed: '1000 FDX',
          port: 'GigabitEthernet0/2',
        },
        {
          length: '16M',
          vlan: 'VLAN 1',
          speed: '1000 FDX',
          port: 'GigabitEthernet0/5',
        },
        {
          length: '42M',
          vlan: 'VLAN 4',
          speed: '1000 FDX',
          port: 'GigabitEthernet0/2',
        },
        {
          length: '12M',
          vlan: 'VLAN 1',
          speed: '1000 FDX',
          port: 'GigabitEthernet0/1',
        },
        {
          length: '90M',
          vlan: 'VLAN 1',
          speed: '1000 FDX',
          port: 'GigabitEthernet0/3',
        },
      ],

      devices: [
        'PC1',
        'PC2',
        'PC3',
        'PC4',
        'PC5',
        'Printer',
        'Server1',
        'Switch1',
        'Switch2',
        'Cable1',
        'Cable2',
        'Cable3',
        'Cable4',
        'Cable5',
        'Cable6',
        'Cable7',
        'Cable8',
      ],

      problems: ['Bad name server', 'Bad reverse IP address', 'Bad subnet', 'Bad IP address', 'Bad gateway address'],

      solutions: [
        'Change IP address',
        'Change gateway address',
        'Change subnet mask',
        'Change DNS address',
        'Flush ARP cache',
        'Release and renew IP address',
      ],

      remediationAnswers: [
        {
          device: 'PC2',
          problemAnswer: 'Bad gateway address',
          solutionAnswer: 'Change gateway address',
          problemValue: null,
          solutionValue: null,
          answer: false,
        },
        {
          device: 'PC3',
          problemAnswer: 'Bad gateway address',
          solutionAnswer: 'Change gateway address',
          problemValue: null,
          solutionValue: null,
          answer: false,
        },
        {
          device: 'Printer',
          problemAnswer: 'Bad gateway address',
          solutionAnswer: 'Change gateway address',
          problemValue: null,
          solutionValue: null,
          answer: false,
        },
        {
          device: 'Printer',
          problemAnswer: 'Bad IP address',
          solutionAnswer: 'Change IP address',
          problemValue: null,
          solutionValue: null,
          answer: false,
        },
      ],

      remediations: [],
    };
  },
  methods: {
    selectCable(index) {
      this.activeCable = index;
    },
    addRemediation() {
      this.remediations.push({
        device: '',
        problem: '',
        solution: '',
      });
    },
    removeRemediation(index) {
      this.remediations.splice(index, 1);
    },
    markSimulation() {
      let totalScore = 0;

      this.components.forEach((field, index) => {
        if (field.value === field.answer) {
          this.components[index].score = true;
          totalScore++;
        } else {
          this.components[index].score = false;
        }
      });

      if (totalScore === this.dataLocal.simulation.totalScore) {
        return this.$emit('simulation_full_correct', totalScore);
      }
      this.$emit('simulation_getting_there', totalScore);
    },
  },
  components: {
    vSelect,
    MovablePopup,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss">
#Lgx02667670704743478461196 {
  .cable {
    position: absolute;
    cursor: url('~@/assets/images/cursor/cursor-pointer.png'), auto;
  }
}
</style>
